import { Component } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixTextComponent } from "../../prefix-text.component";
import { TemplateTextComponent } from "../../templates/template-text/template-text.component";
import { MaxLength } from "../../types/MaxLength";

@Component({
  selector: "app-prefix-oml",
  imports: [TemplateTextComponent],
  templateUrl: "./prefix-oml.component.html",
  styleUrl: "./prefix-oml.component.less",
})
export class PrefixOmlComponent extends PrefixTextComponent {
  public maxlength: MaxLength;

  public constructor() {
    super();
    this.maxlength = 100;
    this.characters = ALLOWED_CHARACTERS["oml"];
  }
}
